module.exports = __webpack_public_path__ + "img/top_bg.f9189088.png";